<p-dialog [header]='setLabel("addVisitorHeaderLabel")' [(visible)]="dialogVisibility" (onHide)="onBeforeDialogHide()">
    <form class="form-1" #visitorSignUpForm="ngForm">
        <h3 class="first">{{setLabel("visitorDetailsLabel")}}</h3>
        <div class="sub-form-1 form-1 p-g-12 p-md-6 p-lg-8 p-xl-6" style="text-align: left">
            <h3 class="first">{{setLabel("dateOfVisitingLabel")}}</h3>
            <div class="detail-add-visitor p-g p-fluid">
                <div class="p-g-12 p-md-10">
                    <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                        [monthNavigator]="true" [(ngModel)]="selectedDate"
                        [placeholder]='setLabel("dateOfVisitingPlaceholderLabel")'
                        name="date" [inline]="false" dateFormat="dd/mm/yy"
                        [showIcon]="true">
                    </p-calendar>
                </div>
                <div class="p-g-12 p-md-10">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-user"
                                aria-hidden="true"></i></span>
                        <input maxlength="100" type="text" id="visitorName" #visitorName
                            pInputText
                            [placeholder]='setLabel("visitorNamePlaceholderLabel")'
                            name="firstName" #firstName="ngModel" [(ngModel)]="visitor.name"
                            required pattern="[A-Za-z ]+"
                            [ngClass]="firstName.invalid && (firstName.dirty || firstName.touched) ? 'errorInput' : '' ">
                    </div>
                    <div
                        *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)">
                        <div *ngIf="firstName.errors.required" class="errorShow">
                            {{setLabel("nameErrorLabel")}}
                        </div>
                        <div *ngIf="firstName.errors.pattern" class="errorShow">
                            {{setLabel("nameLettersErrorLabel")}}
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="first" *ngIf="mode=='add'">{{setLabel("modeOfPaymetLabel")}}</h3>
            <div class="p-g-12" *ngIf="mode=='add'">
                <p-dropdown class="p-g-6" [options]="paymentOptions"
                    (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
            </div>
        </div>
        <div class="form-2 p-g-12 p-md-6 p-lg-8 p-xl-6" style="text-align: left">
            <h3 class="first">{{setLabel("contactDetailsLabel")}}</h3>
            <div class="contact-Detail-fields p-g p-fluid">
                <div class="p-g-12">
                    <div class="p-g-12 p-lg-8 p-xl-12 p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-envelope-o"
                                aria-hidden="true"></i></span>
                        <input maxlength="256" type="email" pInputText
                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                            autocomplete="off"
                            [ngClass]="email.invalid && (email.dirty || email.touched) ? 'errorInput' : '' "
                            [placeholder]='setLabel("emailPlaceholderLabel")' name="email"
                            #email="ngModel" [(ngModel)]="visitor.email" id="visitorEmail">
                    </div>
                    <div *ngIf="email.invalid && (email.dirty || email.touched)">
                        <div *ngIf="email.errors.required" class="errorShow">
                            {{setLabel("emailAddressErrorLabel")}}
                        </div>
                        <div *ngIf="email.errors.pattern" class="errorShow">
                            {{setLabel("validEmailAddressErrorLabel")}}
                        </div>
                    </div>
                </div>
                <div class="p-g-12">
                    <div class="p-g-12 p-lg-8 p-xl-12 p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-phone"
                                aria-hidden="true"></i></span>
                        <input maxlength="11" type="text" required pInputText
                            #contact="ngModel" autocomplete="off" pattern="(03)[0-9]{9}"
                            [ngClass]="contact.invalid && (contact.dirty || contact.touched) ? 'errorInput' : '' "
                            [placeholder]='setLabel("mobilePlaceholderLabel")'
                            name="contact" [(ngModel)]="visitor.phone" id="visitorMobile">
                    </div>
                    <div *ngIf="contact.invalid && (contact.dirty || contact.touched)">
                        <div *ngIf="contact.errors.required" class="errorShow">
                            {{setLabel("mobileErrorLabel")}}
                        </div>
                        <div *ngIf="contact.errors.pattern" class="errorShow">
                            {{setLabel("validMobileLabel")}} {{errorExempleNumber}}
                        </div>
                    </div>
                </div>
                <h3 class="first" *ngIf="mode=='add'">{{setLabel("visitingFeeLabel")}}</h3>
                <div class="p-g-12" *ngIf="mode=='add'">
                    <p-dropdown [options]="visitorTypes" optionLabel="name"
                        (onChange)="onSelect($event)"></p-dropdown>
                    &nbsp;
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money"
                                aria-hidden="true"></i></span>
                        <input type="number"
                            [placeholder]='setLabel("visitingFeePKRPlaceholderLabel")'
                            pInputText #visitingFee="ngModel" name="visitingFee"
                            [(ngModel)]="visitorFee" required autocomplete="off"
                            pattern="[0-9]+" id="visitorFee"
                            [ngClass]="visitingFee.invalid && (visitingFee.dirty || visitingFee.touched) ? 'errorInput' : '' ">
                    </div>
                    <div
                        *ngIf="visitingFee.invalid && (visitingFee.dirty || visitingFee.touched)">
                        <div *ngIf="visitingFee.errors.required" class="errorShow">
                            {{setLabel("visitingFeeErrorLabel")}}
                        </div>
                        <div *ngIf="visitingFee.errors.pattern" class="errorShow">
                            {{setLabel("validVisitingFeeErrorLabel")}}
                        </div>
                    </div>
                    <div class="p-g-12">
                        <span>Does this day pass require a trainer?</span>
                        <p-checkbox [label]='setLabel("trainerLabel")'
                            name="trainingBySomeoneElse"
                            (onChange)="onCheckboxChange()"></p-checkbox>
                    </div>


                    <div class="p-g-12" *ngIf="trainingBySomeoneElse">
                        <span class="p-g-4">{{setLabel("trainerLabel")}}</span>
                        <p-dropdown class="p-g-8" [options]="allTrainers"
                            [(ngModel)]="selectedTrainer"
                            (onChange)="onConductedTrainerChange($event)"
                            [placeholder]='setLabel("selectTrainerPlaceholderLabel")'
                            name="trainerName" optionLabel="name">
                        </p-dropdown>
                    </div>
                </div>
                <div class="p-g-12" *ngIf="mode=='add'">
                    <h3 class="first">{{setLabel("discountLabel")}}</h3>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-money"
                                aria-hidden="true"></i></span>
                        <input type="number"
                            [placeholder]='setLabel("visitingDiscountPKRPlaceholderLabel")'
                            pInputText #visitingDiscount="ngModel" name="visitingDiscount"
                            [(ngModel)]="visitorFeeDiscount" required autocomplete="off"
                            pattern="[0-9]+" id="visitingDiscount"
                            [ngClass]="visitingDiscount.invalid && (visitingDiscount.dirty || visitingDiscount.touched) ? 'errorInput' : '' ">
                    </div>
                    <div
                        *ngIf="visitingDiscount.invalid && (visitingDiscount.dirty || visitingDiscount.touched)">
                        <div *ngIf="visitingDiscount.errors.required" class="errorShow">
                            {{setLabel("visitingDiscountErrorLabel")}}
                        </div>
                        <div *ngIf="visitingDiscount.errors.pattern" class="errorShow">
                            {{setLabel("validVisitingDiscountErrorLabel")}}
                        </div>
                    </div>
                </div>
            </div>
            <h3 *ngIf="mode=='edit'" class="first">{{setLabel("dayPassLabel")}}</h3>
            <div *ngIf="mode=='edit'" class="contact-Detail-fields p-g p-fluid">
                <div class="p-g-12">
                    <div class="p-g-12 p-lg-8 p-xl-12 p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="fa fa-envelope-o"
                                aria-hidden="true"></i></span>
                        <input maxlength="256" type="text" pInputText
                            [placeholder]='setLabel("dayPassPlaceholderLabel")'
                            name="daypass" #daypass="ngModel" [(ngModel)]="visitor.dayPass"
                            id="visitorEmail" readonly>
                    </div>
                </div>
            </div>
            <button (click)="save(visitorSignUpForm)" pButton id="visitorSave" *ngIf="mode == 'add'"
            type="button" icon="pi pi-save"
            class="p-button-success">&nbsp;{{setLabel("saveBtnLabel")}}</button>
        </div>
    </form>
</p-dialog>

<div id="invoice" style="display: none;">
     
    <div class="invoice-box" style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;">
        <div style="width: 57mm;max-width: 57mm;">
            <img [src]="(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                alt="Company Logo"
                style="display: block;margin-left: auto; margin-right: auto;width: 58%;margin-top: 3px; margin-bottom: 2px;">

            <div style="text-align: center;font-size: 11px;line-height: 14px; color: black;">{{company.address}}</div>
            <div style="text-align: center;font-size: 11px;line-height: 15px; color: black;"> {{company.phone}}</div>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">

                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">{{setLabel("invoiceNoLabel")}}</td>
                        <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">{{setLabel("createdDateLabel")}}
                        </td>
                        <!-- <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">Due</td> -->
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center; padding: 0px;">{{fund.invoice}}</td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;"> {{fund.createdDate | date:
                            'dd/MM/yyyy'}}
                        </td>
                        <!-- <td style="font-size: 10px;text-align: center; padding: 0px;">{{fund.date | date:'dd/MM/yyyy'}}</td> -->
                    </tr>

                </tbody>
            </table>

            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">
                <thead
                    style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
                    <tr style="background-color: black;color: white; border: 1px solid black;">

                        <th style="width: 40px;   word-break: break-word; font-size: 10px;" colspan="2">{{setLabel("nameLabel")}}</th>
                        <!-- <th style="width: 40px;   word-break: break-word; font-size: 10px;" >Gmail</th> -->
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("payLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("discountLabel")}}</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("statusLabel")}}</th>

                    </tr>
                </thead>
                <tbody>
                    <span>
                        <tr>

                            <td style="font-size: 9px;border:1px solid black;text-align: center;" colspan="2">
                                {{visitor.name}}</td>
                            <!-- <td style="font-size: 9px;border:1px solid black;text-align: center;" > {{visitor.email}}</td> -->

                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.pay}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.discount}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.status}}</td>
                        </tr>
                    </span>

                    <tr>
                        <td></td>
                        <td style="font-size: 10px; text-align: center;  font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;border-bottom: 1px solid;border-left: 1px solid;"
                            colspan="2">{{setLabel("totalLabel")}}</td>
                        <td style="font-size: 10px;text-align: center; border-right: 1px solid;
                      border-bottom: 1px solid;">{{fund.pay - fund.discount}}</td>

                    </tr>


                </tbody>
            </table>

            <div
                style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black;white-space: nowrap;">
                {{setLabel("softwareProvidedLabel")}}
            </div>

        </div>
    </div>

</div>